/**
 * Static mapping of labware typeId → CyBio Composer MDB database ID.
 *
 * Backward-compatibility fallback for legacy config XMLs that lack `mdb-id`
 * attributes. New configs from the workspace configuration UI include `mdb-id`
 * and don't need this.
 *
 * Includes BOTH old Briefly names (plate-96-deep) and MDB-derived names
 * (abgene-96-pp-storage-plate-2-2-ml-round-bottom) since legacy configs in
 * the field use MDB-derived names.
 *
 * Source: briefly-runner/seed/composer-db/full-catalog.json
 *         briefly-runner/seed/composer-db/typeId-migration-map.json
 */
export const MDB_ID_FALLBACK: Record<string, number> = {
  // === MDB-derived names (used in legacy deployed configs) ===

  // Plates
  "nunc-u96-pp": 370,
  "abgene-96-pp-storage-plate-2-2-ml-round-bottom": 265,
  "greiner-96-half-area-plate-ps": 108,
  "nunc-384-deepwell-pp": 6,
  "greiner-u96-ps": 9,
  "bd-falcon-96-flat-bottom": 23,
  "nunc-96-dw-pp-2-ml": 113,
  "brand-96-pp-dw-plate-0-5-ml": 160,
  "axygen-384-pp-120-ul": 125,

  // Reservoirs
  "axygen-8-row-v-bottom-res-pp-high-profile": 235,
  "axygen-12-col-v-bottom-res-pp-high-profile": 236,
  "nalgene-reservoir-pp-flat-bottom": 289,
  "nalgene-reservoir-pp-flat-bottom--waste": 289,
  "agilent-3-column-res-pp-high-profile-v-bottom": 401,
  "axygen-2-column-res-pp-high-profile-v-bottom": 376,
  "axygen-24-pp-large-volume-reservoir-pyramid-bottom": 371,

  // Tips (with stand suffix)
  "cybio-tip-1000-ul--stand105": 21,
  "cybio-tip-1000-ul--tiprack": 21,
  "cybio-tip-1000-ul--tipbox": 21,
  "cybio-tip-250-ul--tipbox": 24,
  "cybio-tip-250-ul-filter-net-vol-150-ul--tipbox": 26,
  "cybio-tip-50-ul--tipbox": 23,
  "cybio-tip-50-ul-filter-net-vol-40-ul--tipbox": 25,
  "cybio-tip-60-ul--stand100": 16,
  "cybio-tip-60-ul-filter-net-vol-18-ul--stand105": 30,

  // Adapters & devices
  "ol3397-25-231": 1,
  "alpaqua-magnum-flx": 57,
  "ol3317-23-690-bioshake-3000-t-elm-adapter-axygen-v-bottom": 72,
  "ol3317-11-270-maldi-adapter-14-5-mm-height": 83,
  "gripper": 1,
  "waste-box": 13,

  // === Old Briefly names (from labware.json, pre-migration configs) ===
  "adapter-gripper": 1,
  "adapter-select-13": 1,
  "agilent-3-column-res": 401,
  "agilent-384-0.2ml": 125,
  "agilent-reservoir-300ml": 236,
  "bioshake": 72,
  "falcon-96-flat-2.2ml": 23,
  "fisher-96-deep-2ml": 113,
  "magnet": 57,
  "magnet-promega": 83,
  "plate-384": 6,
  "plate-96-deep": 265,
  "plate-96-half-area": 108,
  "plate-96-nunc": 370,
  "reservoir-axygen": 235,
  "reservoir-nalgene": 289,
  "thermo-96-0.8ml": 160,
  "thermo-96-skirted-0.2ml": 9,
  "tipbox": 24,
  "tipbox-250": 24,
  "tipbox-250-filter": 26,
  "tipbox-50": 23,
  "tipbox-50-filter": 25,
  "tipbox-1000": 21,
  "tiprack-1000": 21,
  "tiptray-1000": 21,
  "tiptray-21": 21,
  "tiptray-60": 16,
  "tiptray-60-filter": 30,
  "trash": 1,
  "waste": 289,
};
